import React from 'react';

export default function DonationForm() {
    return (
        <div className="donation-form">
            <iframe
                title="donation-form"
                height="100%"
                frameBorder="0"
                scrolling="no"
                style={{ width: '100%', border: 'none' }}
                src="https://secure.lglforms.com/form_engine/s/hD4Zcr7ohhexEKkoigR21Q">
                <a href="https://secure.lglforms.com/form_engine/s/hD4Zcr7ohhexEKkoigR21Q">
                    Support{' '}
                </a>
            </iframe>
        </div>
    );
}
